<template>
    <div class="wrap">
        <van-sticky>
            <van-nav-bar title="我的分享" left-arrow @click-left="$router.go(-1)" />
        </van-sticky>
        <!-- 列表 -->
        <div class="teamList" v-if='teamList.length>0'>
            <div class="teamItem" v-for='(item,index) in teamList' :key='index'>
                <div>
                    <div class="head_image">
                    <img :src='item.head_image' alt width="50px" height="50px"/>
                    </div>
                    <div style="margin-bottom:5px">
                    {{item.nick_name}}
                    </div>
                    <div style="margin-bottom:5px">
                    ID:{{item.id}}
                    </div>
                    <div style="margin-bottom:5px">
                    单量：{{item.achievement_order_number}}
                    </div>
                </div>
                <div class='itemSon'>
                    <div>账号：{{(item.member).replace( /^(\d{3})\d{4}(\d{4})$/,"$1****$2")}}</div>
                    <div>{{item.create_time}}</div>
                </div>
            </div>
        </div>
        <div v-else class="noData">
            暂无数据
        </div>
    </div>
</template>

<script>
    import { myTeam } from "@/api/team";
    export default {
        data() {
            return {
                teamData: {},
                teamList: []
            };
        },
        created() {
            myTeam(1).then(res => {
                this.teamData = res;
                this.teamList = res.data;
            });
        }
    };
</script>
<style lang='less' scoped>
    .wrap {
        height: 100vh;
        background: #fff;
        color: #343434;
        font-size: 14px;

        .teamTop {
            width: 100%;
            padding: 11px 20px 19px;
            box-sizing: border-box;
            text-align: center;

            .topBtm {
                margin-top: 25px;
                display: flex;
                justify-content: space-between;
                text-align: center;
                &>div{
                    width:33.3%;
                }
                div.num {
                    color: #3B6BFB;
                    font-size: 18px;
                    margin-top: 8.5px;
                }
            }
        }

        .gap {
            width: 100%;
            height: 10px;
            background: #ececec;
        }

        .teamList {
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px;

            .teamItem {
                width: 100%;
                padding: 17px 0 10px;
                box-sizing: border-box;
                border-bottom: 1px solid #d3d3d3;
            }
        }
    }

    .itemSon {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-bottom: 10px;
        margin-top: 10px;
        flex-wrap: wrap;

        div {
            width: 50%;

            &:last-child {
                text-align: right;
            }
        }
    }
    .head_image{
        float:left;
        margin-right:10px;
        height:50px;
        width:50px;
    }
</style>